import {
  ActionAdd,
  ActionAddShownMiners,
  ActionBaseMinersSelect,
  ActionRemove,
  ActionSelect,
  ActionSelectAll,
  ActionSetShownMiners,
  ActionTypesMinersSelect,
  idsArrayToIDSet,
  manyMinersSelected,
  MinersSelectionI,
  ActionExcludeMinersFromAllSelected,
  ActionIncludeMinersToAllSelected,
  MinersIDSetI,
  SelectedMinerI,
  RequestParamsI,
  ActionSetRequestParams,
  ActionScrollTo,
  ActionSetDrag,
  ActionSetTab,
  ActionNeedDeselect,
  ActionSetSubTabNum,
  ActionSetSubTabs,
  ActionSetDragOverTab,
} from "./actionTypes";
import { SearchPart } from "@components/Pages/Machines/Search/Search.props";
import { Tab } from "./actionTypes";

export interface MinersSelectState extends MinersSelectionI {
  tab: Tab;
  subtab?: number;
  subTabs: SearchPart[];
  dragMinersIDs?: string[];
  dragFromTab?: Tab;
  params?: RequestParamsI;
  received?: number;
  scrollToMinerID?: number;
  needDeselectAll?: boolean;
  dragOverTabID?: Tab;
}

export const draggableHTMLID = (minerID: string) => `draggable_row_${minerID}`;

const initialState: MinersSelectState = {
  selected: [],
  tab: Tab.ALL,
  subTabs: [],
};

const concatNoRepeat = (
  a: SelectedMinerI[],
  b: SelectedMinerI[]
): SelectedMinerI[] => {
  const tab: Record<string, number> = {};
  for (const aa of a) {
    tab[aa.id] = 1;
  }
  const result = [...a];
  for (const bb of b) {
    if (!tab.hasOwnProperty(bb.id)) {
      result.push(bb);
    }
  }
  return result;
};

const minersTableReducer = (
  state: MinersSelectState = initialState,
  action: ActionBaseMinersSelect
): MinersSelectState => {
  //if (action.type.startsWith("MINERS_SELECT")) console.log("HERE ACTION #$%", state, action);
  switch (action.type) {
    case ActionTypesMinersSelect.SELECT: {
      const act = action as ActionSelect;
      return { ...state, ...act.payload };
    }
    case ActionTypesMinersSelect.ADD: {
      const act = action as ActionAdd;
      if (manyMinersSelected(state)) {
        const act2: ActionIncludeMinersToAllSelected = {
          type: ActionTypesMinersSelect.INCLUDE,
          payload: act.payload.map((m) => m.id),
        };
        return minersTableReducer(state, act2);
      }
      const result = {
        ...state,
        selected: concatNoRepeat(state.selected, act.payload), //TODO: fix repeat?
      };
      return result;
    }
    case ActionTypesMinersSelect.REMOVE: {
      const act = action as ActionRemove;
      const tab = idsArrayToIDSet(act.payload);
      if (manyMinersSelected(state)) {
        const act2: ActionExcludeMinersFromAllSelected = {
          type: ActionTypesMinersSelect.EXCLUDE,
          payload: act.payload,
        };
        return minersTableReducer(state, act2);
      }
      return {
        ...state,
        selected: state.selected.filter((m) => !tab.hasOwnProperty(m.id)),
      };
    }
    case ActionTypesMinersSelect.SELECT_ALL: {
      const act = action as ActionSelectAll;
      return {
        ...state,
        selected: [...(act.payload.page || [])],
        query: act.payload.query,
        total: act.payload.total,
        received: act.payload.page?.length || 0,
      };
    }
    case ActionTypesMinersSelect.REMOVE_ALL: {
      return { ...state, selected: [] }; // иначе сбрасываются фильтры поиска
    }
    case ActionTypesMinersSelect.SET_SHOWN: {
      const act = action as ActionSetShownMiners;
      const result = {
        ...state,
        total: act.payload.total,
        selected: [...(act.payload.miners || [])],
        received: act.payload.received,
      };
      return result;
    }
    case ActionTypesMinersSelect.ADD_SHOWN: {
      if (!manyMinersSelected(state)) {
        return state;
      }
      const act = action as ActionAddShownMiners;
      return {
        ...state,
        total: act.payload.total,
        selected: concatNoRepeat(state.selected, act.payload.miners),
        received: (state.received || 0) + act.payload.received,
      };
    }
    case ActionTypesMinersSelect.EXCLUDE: {
      if (!manyMinersSelected(state)) {
        return state;
      }
      const act = action as ActionExcludeMinersFromAllSelected;
      return {
        ...state,
        excluded: { ...state.excluded, ...idsArrayToIDSet(act.payload) },
      };
    }
    case ActionTypesMinersSelect.INCLUDE: {
      if (!state.excluded) {
        return state;
      }
      const act = action as ActionIncludeMinersToAllSelected;
      const tab = idsArrayToIDSet(act.payload);
      const newExcluded: MinersIDSetI = {};
      for (const id of Object.keys(state.excluded)) {
        if (!tab.hasOwnProperty(id)) {
          newExcluded[id] = 1;
        }
      }
      return {
        ...state,
        excluded: newExcluded,
      };
    }
    case ActionTypesMinersSelect.SET_REQUEST_PARAMS: {
      const act = action as ActionSetRequestParams;
      const result = { ...state, params: act.payload };
      return result;
    }
    case ActionTypesMinersSelect.SCROLL_TO: {
      const act = action as ActionScrollTo;
      return { ...state, scrollToMinerID: act.payload };
    }
    case ActionTypesMinersSelect.RESET_SCROLL: {
      return { ...state, scrollToMinerID: undefined };
    }
    case ActionTypesMinersSelect.SET_DRAG: {
      const act = action as ActionSetDrag;
      return {
        ...state,
        dragMinersIDs: act.payload.ids,
        dragFromTab: act.payload.fromTab,
      };
    }
    case ActionTypesMinersSelect.SET_TAB: {
      const act = action as ActionSetTab;
      return { ...state, tab: act.payload };
    }
    case ActionTypesMinersSelect.SET_SUBTAB_NUM: {
      const act = action as ActionSetSubTabNum;
      return { ...state, subtab: act.payload };
    }
    case ActionTypesMinersSelect.SET_SUBTABS: {
      const act = action as ActionSetSubTabs;

      return {
        ...state,
        subTabs: act.payload,
        subtab: act.payload.length > 1 ? 0 : undefined,
      };
    }
    case ActionTypesMinersSelect.NEED_DESELECT: {
      const act = action as ActionNeedDeselect;
      return { ...state, needDeselectAll: act.payload };
    }
    case ActionTypesMinersSelect.SET_DRAG_OVER_TAB: {
      const act = action as ActionSetDragOverTab;
      return { ...state, dragOverTabID: act.payload };
    }
    default:
      return state;
  }
};

export default minersTableReducer;
